import { useState, useEffect, useCallback } from 'react';
import { getApiBaseUrl } from '../utils/api';

const API_BASE_URL = getApiBaseUrl();

const useGroupsData = (user) => {
  // State for groups data
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  
  // Pagination state
  const [groupsPagination, setGroupsPagination] = useState({
    current_page: 1,
    per_page: 25,
    total: 0,
    total_pages: 0,
    has_next: false,
    has_prev: false
  });
  
  // Search states
  const [groupSearchTerm, setGroupSearchTerm] = useState("");
  const [groupDomain, setGroupDomain] = useState("");

  // Fetch groups function
  const fetchGroups = useCallback(async (page = 1, search = "", domain = "") => {
    if (!user?.id) {
      console.error("User ID not available");
      return;
    }
    
    try {
      setLoading(true);
      const params = new URLSearchParams({
        user_id: user.id,
        page: page,
        per_page: 25
      });
      
      if (search) {
        params.append("search", search);
      }
      if (domain) {
        params.append("domain", domain);
      }
      
      const response = await fetch(`${API_BASE_URL}/admin/groups?${params}`);
      const data = await response.json();
      setGroups(data.groups || []);
      setGroupsPagination(
        data.pagination || {
          current_page: page,
          per_page: 25,
          total: 0,
          total_pages: 0,
          has_next: false,
          has_prev: false
        }
      );
    } catch (error) {
      console.error("Error fetching groups:", error);
      setError("Erro ao carregar grupos");
    } finally {
      setLoading(false);
    }
  }, [user?.id]);

  // Initialize data on mount
  useEffect(() => {
    if (user?.id) {
      fetchGroups();
    }
  }, [user?.id, fetchGroups]);

  return {
    // Data
    groups,
    groupsPagination,
    
    // States
    loading,
    error,
    setError,
    
    // Search
    groupSearchTerm,
    setGroupSearchTerm,
    groupDomain,
    setGroupDomain,
    
    // Functions
    fetchGroups
  };
};

export default useGroupsData;
